import { jsx as _jsx } from "preact/jsx-runtime";
import styles from '../styles/Dots.module.scss';
export default function Dots({ pages, page, onDotClick }) {
    if (!pages) {
        return null;
    }
    const dots = Array.from(Array(pages).keys());
    return (_jsx("ul", Object.assign({ className: styles.wrapper }, { children: dots.map((dot, index) => (_jsx("li", { children: _jsx("button", { name: `paginationDot-${index}`, className: `${styles.dot} ${dot === page ? styles.dotActive : styles.dotInactive}`, onClick: () => onDotClick(dot), "aria-label": `page ${index + 1}` }, index) }, void 0))) }), void 0));
}
